const title = "Order Guide – Team Banner Sports";

export {title}